module.exports = __webpack_public_path__ + "img/horizontal_4_6_5.638ca0d8.png";